<template>
    <div v-if="testimonials" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TestimonialCard
            v-for="testimonial in testimonials"
            :key="testimonial.id"
            :text="testimonial.text"
            :user="testimonial.user"
        />
    </div>
</template>

<script>
import TestimonialCard from './TestimonialCard';
export default {
    components: { TestimonialCard },
    data() {
        return {
            testimonials: null
        };
    },

    mounted() {
        this.fetchTestimonials();
    },

    methods: {
        fetchTestimonials() {
            axios(`/api/testimonials`).then(response => {
                this.testimonials = response.data.data;
            });
        }
    }
};
</script>
